import React, { useEffect, useState } from 'react';
import { fetchLanguages, createLanguage, updateLanguage, deleteLanguage } from '../api';
import { Button } from '../components/ui/button';
import { Pencil, Trash2 } from 'lucide-react';

function LanguagesPage() {
  const [languages, setLanguages] = useState([]);
  const [form, setForm] = useState({ name: '', abreviation: '' });
  const [editingId, setEditingId] = useState(null);
  const [editForm, setEditForm] = useState({ name: '', abreviation: '' });

  useEffect(() => {
    fetchLanguages().then(setLanguages);
  }, []);

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    if (!form.name || !form.abreviation) return;
    await createLanguage(form);
    setLanguages(await fetchLanguages());
    setForm({ name: '', abreviation: '' });
  };

  const startEdit = l => {
    setEditingId(l.language_id);
    setEditForm({ name: l.name, abreviation: l.abreviation });
  };

  const handleEditChange = e => {
    setEditForm({ ...editForm, [e.target.name]: e.target.value });
  };

  const handleEditSubmit = async e => {
    e.preventDefault();
    await updateLanguage(editingId, editForm);
    setLanguages(await fetchLanguages());
    setEditingId(null);
  };

  const handleDelete = async id => {
    await deleteLanguage(id);
    setLanguages(await fetchLanguages());
  };

  return (
    <div className="container mx-auto p-4 space-y-6">
      <h1 className="text-3xl font-bold">Languages</h1>
      
      <form onSubmit={handleSubmit} className="bg-card p-6 rounded-lg shadow-sm space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <input
            name="name"
            value={form.name}
            onChange={handleChange}
            placeholder="Language Name"
            required
            className="px-3 py-2 rounded-md border border-input bg-background"
          />
          <input
            name="abreviation"
            value={form.abreviation}
            onChange={handleChange}
            placeholder="Abbreviation"
            required
            className="px-3 py-2 rounded-md border border-input bg-background"
          />
        </div>
        <Button type="submit">Add Language</Button>
      </form>

      <div className="space-y-4">
        {languages.length === 0 ? (
          <p className="text-center text-muted-foreground">No languages found</p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {languages.map((language) => (
              <div
                key={language.language_id}
                className="bg-card text-card-foreground rounded-lg border p-4 shadow-sm hover:shadow-md transition-shadow"
              >
                {editingId === language.language_id ? (
                  <form onSubmit={handleEditSubmit} className="space-y-4">
                    <div className="space-y-4">
                      <input
                        name="name"
                        value={editForm.name}
                        onChange={handleEditChange}
                        required
                        className="w-full px-3 py-2 rounded-md border border-input bg-background"
                      />
                      <input
                        name="abreviation"
                        value={editForm.abreviation}
                        onChange={handleEditChange}
                        required
                        className="w-full px-3 py-2 rounded-md border border-input bg-background"
                      />
                    </div>
                    <div className="flex gap-2">
                      <Button type="submit" size="sm">Save</Button>
                      <Button variant="outline" size="sm" onClick={() => setEditingId(null)}>Cancel</Button>
                    </div>
                  </form>
                ) : (
                  <div className="space-y-2">
                    <div className="flex justify-between items-start">
                      <div>
                        <h3 className="font-semibold text-lg">{language.name}</h3>
                        <p className="text-sm text-muted-foreground">({language.abreviation})</p>
                      </div>
                      <div className="flex gap-2">
                        <Button
                          variant="ghost"
                          size="sm"
                          onClick={() => startEdit(language)}
                        >
                          <Pencil className="h-4 w-4" />
                        </Button>
                        <Button
                          variant="ghost"
                          size="sm"
                          onClick={() => handleDelete(language.language_id)}
                        >
                          <Trash2 className="h-4 w-4" />
                        </Button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default LanguagesPage; 